import React from 'react';
import { Link } from 'react-router-dom';
import { Info } from '@mui/icons-material';

/* eslint-disable react/prop-types */
const Breadcrumb = ({ pageName, pageSubtitle, pageActions = [] }) => {
  const hasHeading = Boolean(
    (pageName && pageName.trim()) || (pageSubtitle && pageSubtitle.trim())
  );

  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
      <div className="flex flex-col gap-1">
        {pageName && pageName.trim() && (
          <h2 className="text-title-md2 font-semibold text-black dark:text-white">
            {pageName}
          </h2>
        )}
        {pageSubtitle && (
          <p className="text-sm font-medium text-gray-600 dark:text-gray-400">
            {pageSubtitle}
          </p>
        )}
      </div>

      <div className="flex flex-col items-start gap-2 sm:items-end">
        {hasHeading && (
          <nav>
            <ol className="flex items-center gap-2">
              <li>
                <Link className="font-medium" to="/">
                  Dashboard /
                </Link>
              </li>
              {pageName && pageName.trim() && (
                <li className="font-medium text-primary">{pageName}</li>
              )}
            </ol>
          </nav>
        )}

        {pageActions.length > 0 && (
          <div className="flex flex-wrap items-center gap-3">
            {pageActions.map((action, index) => {
              const isIconOnly = action.style === 'icon';
              const isExternal = /^https?:\/\//.test(action.href);
              const Action = isExternal ? 'a' : Link;
              return (
                <Action
                  key={index}
                  {...(isExternal
                    ? { href: action.href, target: '_blank', rel: 'noreferrer' }
                    : { to: action.href })}
                  className={`inline-flex items-center justify-center gap-1.5 rounded-md transition-all duration-300 active:scale-95 ${
                    isIconOnly
                      ? 'h-8 w-8 border border-stroke bg-white text-gray-700 shadow-sm hover:border-primary hover:text-primary hover:shadow-md dark:border-strokedark dark:bg-boxdark dark:text-gray-300 dark:hover:border-primary'
                      : 'bg-primary px-3.5 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-opacity-90 hover:shadow-md'
                  }`}
                  title={isIconOnly ? action.label : ''}
                >
                  {action.label === 'I' && isIconOnly ? (
                    <Info sx={{ fontSize: 18 }} />
                  ) : (
                    <span>{action.label}</span>
                  )}
                </Action>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default Breadcrumb;
